import React from 'react';

import { Header } from 'semantic-ui-react';
import * as S from './styles';

export default function Typography() {
  return (
    <S.Section>
      <h2>Typography</h2>
      <S.SectionRow>
        <Header as='h1'>H1 Header</Header>
        <Header as='h2'>H2 Header</Header>
        <Header as='h3'>H3 Header</Header>
        <Header as='h4'>H4 Header</Header>
        <Header as='h5'>H5 Header</Header>
        <Header as='h6'>H6 Header</Header>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
          Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
          Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
        <pre>
          {[
            '<Header as=\'h1\'>H1 Header</Header>',
            '<Header as=\'h2\'>H2 Header</Header>',
            '<Header as=\'h3\'>H3 Header</Header>',
            '<Header as=\'h4\'>H4 Header</Header>',
            '<Header as=\'h5\'>H5 Header</Header>',
            '<Header as=\'h6\'>H6 Header</Header>',
            `<p>
  Lorem ipsum dolor sit amet......
</p>`
          ].join('\n')}
        </pre>
      </S.SectionRow>
    </S.Section>
  );
}